/* eslint-disable react-hooks/exhaustive-deps */
import { Avatar, Backdrop, Box, Button, CircularProgress, Divider, Fade, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { fileApiRoute } from "../../../services/networkService";
import PageService from "../../../services/pageService";
import { formatPrice } from "../../../utils";


const ViewPageModal = ({ open,
    handleClose,
    pageId }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [page, setPage] = useState({});
    const [isModalLoading, setIsModalLoading] = useState(true);

    const Page = async () => {
        try {
            const data = await PageService.fetchOne(pageId);
            setPage(data);
            setIsModalLoading(false);
        } catch (error) {
            console.error('Error fetching page:', error);
        }
    };

    useEffect(() => {
        setIsModalLoading(true);
        if (open) {
            Page();
        }
    }, [open]);


    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            aria-hidden="false"
            aria-modal="true"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isTablet ? '90%' : '60%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: isMobile ? 2 : 4,
                        height: '80vh',
                        overflowY: 'scroll'
                    }}
                >
                    {isModalLoading ? <Box sx={{ justifyContent: 'center', display: 'flex', my: 10 }} >
                        <CircularProgress color="primary" size={28} />
                    </Box>
                        : <Box>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>

                                <Typography id="transition-modal-title" variant="h6" component="h2">
                                    {t('pageInfo')}
                                </Typography>
                                <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                            </Box>

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: isMobile ? 'column' : 'row',
                                    width: '100%'
                                }}>

                                {/* col 1 */}
                                <Box width={isMobile ? '100$' : '50%'}>
                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('id')}: <span style={{ fontWeight: 'bold' }}>{page.id}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('name')}: <span style={{ fontWeight: 'bold' }}>{page.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('ownerName')}: <span style={{ fontWeight: 'bold' }}>{page.ownerName}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('branch')}: <span style={{ fontWeight: 'bold' }}>{page.branch && page.branch.name}</span>
                                    </Typography>

                                    {/* status */}
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                        <Typography variant="body1" sx={{ mt: 2 }}>
                                            {t('status')}:
                                        </Typography>
                                        <Box
                                            sx={{
                                                justifyContent: 'center',
                                                display: 'flex',
                                                py: 0.2,
                                                mt: 2,
                                                mx: 0.3
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    fontWeight: 'bold',
                                                    color: page.status === 'active' ? theme.palette.green.box : theme.palette.red.box,
                                                }}
                                            >
                                                {t(page.status)}
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('posts')}: <span style={{ fontWeight: 'bold' }}>{page.posts}</span>
                                    </Typography>
                                </Box>

                                {/* col 2 */}
                                <Box width={isMobile ? '100$' : '50%'}>
                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('phone')}: <span style={{ fontWeight: 'bold' }}>{page.phone}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('phoneTwo')}: <span style={{ fontWeight: 'bold' }}>{page.phoneTwo}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('instgram')}: <span style={{ fontWeight: 'bold' }}>{page.instgram}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('facebook')}: <span style={{ fontWeight: 'bold' }}>{page.facebook}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('wallet')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(page.wallet)}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('remainAmount')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(page.remainAmount)}</span>
                                    </Typography>

                                </Box>

                            </Box>

                            {/* note */}
                            <Typography variant="body1"
                                sx={{
                                    mt: 1.5,
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    maxHeight: '4.5em',
                                    lineHeight: '1.5em'
                                }}>
                                {t('note')}: <span style={{ fontWeight: 'bold' }}>{page.note}</span>
                            </Typography>

                            <Divider sx={{ mt: 2, mb: 1 }} />
                            <Box
                                sx={{
                                    display: 'flex',
                                    overflowX: isMobile ? 'scroll' : 'hidden'
                                }}>
                                <Box width={isMobile ? '130px' : '20%'}>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                        {t('prices')}:
                                    </Typography>
                                </Box>

                                <Box width={isMobile ? '130px' : '40%'}>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                        {t('city')}:
                                    </Typography>
                                </Box>

                                <Box width={isMobile ? '150px' : '40%'}>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                        {t('transportationPrice')}:
                                    </Typography>
                                </Box>

                            </Box>

                            {
                                page.cityPages.map((city, index) => (
                                    <Box
                                        sx={{
                                            display: 'flex'
                                        }}>
                                        <Box width={isMobile ? '130px' : '20%'}>
                                            <Typography variant="body1" sx={{ mt: 1 }}>
                                                {index + 1}
                                            </Typography>
                                        </Box>

                                        <Box width={isMobile ? '130px' : '40%'}>
                                            <Typography variant="body1" sx={{ mt: 1 }}>
                                                {city.city.name}
                                            </Typography>
                                        </Box>

                                        <Box width={isMobile ? '150px' : '40%'}>
                                            <Typography variant="body1" sx={{ mt: 1 }}>
                                                {formatPrice(city.transportationPrice)}
                                            </Typography>
                                        </Box>

                                    </Box>
                                ))
                            }


                            <Divider sx={{ mb: 2, mt: 1 }} />

                            {/* images */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                    mt: 2
                                }}>
                                <Box sx={{ width: '48%' }}>
                                    <Typography variant="body1">
                                        {t('image')}:
                                    </Typography>
                                    <Avatar
                                        variant="rounded"
                                        src={`${fileApiRoute}/${page.image}`}
                                        sx={{
                                            cursor: 'pointer',
                                            width: '100%',
                                            height: '20vh',
                                            mt: 1
                                        }}
                                    />
                                </Box>

                                <Box sx={{ width: '48%' }}>
                                    <Typography variant="body1">
                                        {t('IDimage')}:
                                    </Typography>
                                    <Avatar
                                        variant="rounded"
                                        src={`${fileApiRoute}/${page.IDImage}`}
                                        sx={{
                                            cursor: 'pointer',
                                            width: '100%',
                                            height: '20vh',
                                            mt: 1
                                        }}
                                    />
                                </Box>

                            </Box>

                            <Box sx={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                mt: 2
                            }}>
                                {/* close */}
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    sx={{ textTransform: 'none', width: 140, height: 40 }}
                                    onClick={handleClose}
                                >
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p>{t('close')}</p>
                                        <CloseOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                    </Box>
                                </Button>

                                <Box width={20}></Box>

                            </Box>
                        </Box>
                    }
                </Box>
            </Fade>
        </Modal>
    );
}

export default ViewPageModal;
